import React, { Component } from "react";
import TeamWeekForm from "../TeamWeekForm/TeamWeekForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LicensesPage
Description : Compoente que alberga el formulario de Licenses definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class TeamWeekPage extends Component {
    render() {
        return (
            <div>
                <TeamWeekForm />
            </div>
        )
    }
}

export default TeamWeekPage;